module.exports = __webpack_public_path__ + "static/media/texto_4.3524c4b0.png";